import React,{Component} from 'react';
import {createMarkup} from './Factory';
import Flexbox from '../components/misc/Flexbox'; 

class About extends Component {
	constructor() {
		super();		
		this.toggleClass = this.toggleClass.bind(this);
	}
	
	toggleClass(index,dis){
		dis.refs['toggle-li-'+index].classList.toggle('open');
		dis.refs['toggle-icon-'+index].classList.toggle('pointer-up');
		dis.refs['toggle-list-'+index].classList.toggle('invisible');
		dis.refs['toggle-list-'+index].classList.toggle('visible');
	}
	render(){				
		const { 
			address_left,address_right,address_line_1,address_line_2,address_line_3,address_telephone,address_fax,address_email,address_email_link,
			offnungszeiten_left,offnungszeiten_right,offnungszeiten_text,
			eintrittspreise_left,eintrittspreise_right,eintrittspreise,
			anfahrt_left,anfahrt_right,anfahrt_map,anfahrt_map_link,
			allgemeine_heading,allgemeine_description,allgemeine_text
	
		} = this.props;		
		const {label_map} = this.props.staticData;
		let divStyle = {
				backgroundImage: 'url(' + anfahrt_map[0] + ')',
				backgroundSize: 'cover',
				maxWidth: '100%',
		}
		return(
			<div>
			<div className="container-fluid lg-side-padding about">	
				<div className="row">
					<div className="col-md-4">
						<Flexbox extra="h2 margin-top-20-mobile" left={address_left} right={address_right} />
						<p>
							<b>{address_line_1}</b><br/>
							{address_line_2}<br/>
							{address_line_3}
						</p>
						<p className="margin-top-30">                    
							<a href={`tel:${address_telephone}`}>T +{address_telephone}</a><br/>
							<a className="mail" href={`mailto:${address_email_link}`}>{address_email}</a>
						</p>
					</div>
					<div className="col-md-4">

						<Flexbox extra="margin-top-50-tablet h2" left={offnungszeiten_left} right={offnungszeiten_right} />
						<div dangerouslySetInnerHTML={createMarkup(offnungszeiten_text)}></div>
					</div>
					 <div className="col-md-4">                
						<Flexbox extra="margin-top-50-tablet h2" left={eintrittspreise_left} right={eintrittspreise_right} />
						<div dangerouslySetInnerHTML={createMarkup(eintrittspreise)}></div>
					</div> 
				</div>
			</div>
			<div className="container-fluid lg-side-padding">
				<div className="row">            
					<div className="col-md-12">
						<Flexbox extra="margin-top-50 h2" left={anfahrt_left} right={anfahrt_right} />
						<div className="map-container" style={divStyle}>
							<div className="btn locate-btn sm-txt"><a target="_blank" href={anfahrt_map_link} >{label_map}</a></div>
						</div>
					</div>
				</div>
			</div>
			<div className="container-fluid lg-side-padding">
				<div className="row">            
					<div className="col-md-12">
						<div className="toggle-list">
							<div className="toggle-list-details-desc" dangerouslySetInnerHTML={createMarkup(allgemeine_text)}></div>
						</div>
					</div>
				</div>
			</div> 
			<div className="container-fluid lg-side-padding">
				<div className="row">            
					<div className="col-md-12">	
						<ul className="toggle-list margin-top-0">
						{
							allgemeine_heading.map( (data,i)=>
								<li key={i} ref={`toggle-li-${i}`} onClick={()=>this.toggleClass(i,this)}>
									<span className="toggle-list-title h2">
										{data}<i ref={`toggle-icon-${i}`} className="icon-arrow-down"></i>
									</span>
									<div ref={`toggle-list-${i}`} className="toggle-list-details invisible">
										<div className="toggle-list-details-desc" dangerouslySetInnerHTML={createMarkup(allgemeine_description[i])}></div>
									</div>
								</li>
							)
						}
						</ul>						
					</div>
				</div>
			</div>
			</div> 			
		)
	}
}
export default About;




// WEBPACK FOOTER //
// ./src/components/About.js